import { FC, ReactNode } from "react";

import styles from "./FormCheckbox.module.css";

interface Props {
  checked: boolean;
  onChange: (checked: boolean) => void;
  children: ReactNode;
  disabled?: boolean;
}

// Нативный input скрыт, но остаётся в разметке: фокус, пробел
// и disabled от fieldset работают как у обычного чекбокса.
export const FormCheckbox: FC<Props> = ({
  checked,
  onChange,
  children,
  disabled,
}) => (
  <label className={styles.checkbox}>
    <input
      type="checkbox"
      className={styles.input}
      checked={checked}
      disabled={disabled}
      onChange={(event) => onChange(event.target.checked)}
    />
    <span className={styles.box} aria-hidden="true" />
    {children}
  </label>
);
